<script>
	//that.GLOBAL.adminId
	// 暴露出这些属性和方法
	export default {
		// httpUrl: 'http://192.168.12.32:8080',
       	// httpUrl: '/api',
		// httpUrl: 'http://njsg.f3322.org:8772',
		// httpUrl: 'http://192.168.11.170:84/njsgorg',
		//测试库
		// httpUrl: 'http://njsg.f3322.org:6690',
		//正式库
		 httpUrl: 'http://js-chinaarts.com',
		// httpUrl: 'http://221.226.72.130:6060',
		
		adminId: window.localStorage.getItem('sysadminId'),
		// adminId:1,
		loginTime: window.localStorage.getItem('loginTime'),
		username: window.localStorage.getItem('username'),
		useraccount:window.localStorage.getItem('useraccount'),
		zhanghao: window.localStorage.getItem('zhanghao'),
		password: window.localStorage.getItem('password'),
		checked: window.localStorage.getItem('checked'),
		token: window.localStorage.getItem('token'),
		filepic: window.localStorage.getItem('filepic'),
		companyuuid: window.localStorage.getItem('companyuuid'),
		projectflag: window.localStorage.getItem('projectflag'),
		shipmentnumber:window.localStorage.getItem('shipmentnumber'),
		defaultActive: window.localStorage.getItem('defaultActive'),
		dateFmt: (dateStr, type) => {
			if (dateStr == undefined || dateStr == '') {
				return '';
			}
			var date = new Date(dateStr);
			var year = '' + date.getFullYear() + '';
			var month = '' + (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1 + '';
			var day = '' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '';
			var returnDate;
			if (type == 'day') {
				returnDate = year + month + day;
			} else if (type == 'month') {
				returnDate = year + month;
			} else if (type == 'wgfenxi') {
				returnDate = month + '月' + day + '日';
			} else {
				returnDate = year;
			}
			return returnDate;
		},
		getTime: (a) => {
			if (a == '' || a == null) {
				return '';
			} else {
				a = new Date(a);
				var year = a.getFullYear();
				var mon = a.getMonth() + 1;
				var month = mon > 9 ? mon : '0' + mon;
				var day = a.getDate() > 9 ? a.getDate() : '0' + a.getDate();
				var hour = a.getHours() > 9 ? a.getHours() : '0' + a.getHours();
				var min = a.getMinutes() > 9 ? a.getMinutes() : '0' + a.getMinutes();
				var s = a.getSeconds() > 9 ? a.getSeconds() : '0' + a.getSeconds();
				return year + '-' + month + '-' + day;
		
			}
		},
		getsfm: (a) => {
			if (a == '' || a == null) {
				return '';
			} else {
				a = new Date(a);
				var year = a.getFullYear();
				var mon = a.getMonth() + 1;
				var month = mon > 9 ? mon : '0' + mon;
				var day = a.getDate() > 9 ? a.getDate() : '0' + a.getDate();
				var hour = a.getHours() > 9 ? a.getHours() : '0' + a.getHours();
				var min = a.getMinutes() > 9 ? a.getMinutes() : '0' + a.getMinutes();
				var s = a.getSeconds() > 9 ? a.getSeconds() : '0' + a.getSeconds();
				return hour + ':' + min + ':' + s;
		
			}
		},
		shifenmiao:(a)=>{
			if (a == '' || a == null) {
				return '';
			} else {
				a = new Date(a);
				var year = a.getFullYear();
				var mon = a.getMonth() + 1;
				var month = mon > 9 ? mon : '0' + mon;
				var day = a.getDate() > 9 ? a.getDate() : '0' + a.getDate();
				var hour = a.getHours() > 9 ? a.getHours() : '0' + a.getHours();
				var min = a.getMinutes() > 9 ? a.getMinutes() : '0' + a.getMinutes();
				var s = a.getSeconds() > 9 ? a.getSeconds() : '0' + a.getSeconds();
				return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + s;
		
			}
		},
		getDateDiff:(dateStr) => {
			var publishTime = new Date(dateStr).getTime() / 1000,
				d_seconds,
				d_minutes,
				d_hours,
				d_days,
				timeNow = parseInt(new Date().getTime() / 1000),
				d,

				date = new Date(publishTime * 1000),
				Y = date.getFullYear(),
				M = date.getMonth() + 1,
				D = date.getDate(),
				H = date.getHours(),
				m = date.getMinutes(),
				s = date.getSeconds();
			//小于10的在前面补0
			if (M < 10) {
				M = '0' + M;
			}
			if (D < 10) {
				D = '0' + D;
			}
			if (H < 10) {
				H = '0' + H;
			}
			if (m < 10) {
				m = '0' + m;
			}
			if (s < 10) {
				s = '0' + s;
			}

			d = timeNow - publishTime;
			d_days = parseInt(d / 86400);
			d_hours = parseInt(d / 3600);
			d_minutes = parseInt(d / 60);
			d_seconds = parseInt(d);

			if (d_days > 0 && d_days < 3) {
				return d_days + '天前';
			} else if (d_days <= 0 && d_hours > 0) {
				return d_hours + '小时前';
			} else if (d_hours <= 0 && d_minutes > 0) {
				return d_minutes + '分钟前';
			} else if (d_seconds < 60) {
				if (d_seconds <= 0) {
					return '刚刚';
				} else {
					return d_seconds + '秒前';
				}
			} else if (d_days >= 3) {
				return dateStr;
			}
			// else if (d_days >= 30) {
			// 	return Y + '-' + M + '-' + D + ' ' + H + ':' + m;
			// }
		},
		numFormat(num) {
			var c = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
			return c;
		}
	}
</script>
